import { Action } from '@ngrx/store'
import * as StreetsTypes from './streets.types'
import { Street } from './streets.interface'

export class FetchStreetsRequest implements Action {
  readonly type = StreetsTypes.FETCH_STREETS_REQUEST
  constructor(public payload: any) {}
}

export class FetchStreetsSuccess implements Action {
  readonly type = StreetsTypes.FETCH_STREETS_SUCCESS
  constructor(
    public payload: Street[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchStreetsFailure implements Action {
  readonly type = StreetsTypes.FETCH_STREETS_FAILURE
  constructor(public payload: any) {}
}

export class FetchStreetRequest implements Action {
  readonly type = StreetsTypes.FETCH_STREET_REQUEST
  constructor(public id: number) {}
}

export class FetchStreetSuccess implements Action {
  readonly type = StreetsTypes.FETCH_STREET_SUCCESS
  constructor(public payload: Street) {}
}

export class FetchStreetFailure implements Action {
  readonly type = StreetsTypes.FETCH_STREET_FAILURE
  constructor(public payload: any) {}
}

export class DeleteStreetRequest implements Action {
  readonly type = StreetsTypes.DELETE_STREET_REQUEST
  constructor(public id: number) {}
}

export class DeleteStreetSuccess implements Action {
  readonly type = StreetsTypes.DELETE_STREET_SUCCESS
  constructor() {}
}

export class DeleteStreetFailure implements Action {
  readonly type = StreetsTypes.DELETE_STREET_FAILURE
  constructor(public payload: any) {}
}

export class CreateStreetRequest implements Action {
  readonly type = StreetsTypes.CREATE_STREET_REQUEST
  constructor(public payload) {}
}

export class CreateStreetSuccess implements Action {
  readonly type = StreetsTypes.CREATE_STREET_SUCCESS
  constructor() {}
}

export class CreateStreetFailure implements Action {
  readonly type = StreetsTypes.CREATE_STREET_FAILURE
  constructor(public payload: any) {}
}

export class UpdateStreetRequest implements Action {
  readonly type = StreetsTypes.UPDATE_STREET_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateStreetSuccess implements Action {
  readonly type = StreetsTypes.UPDATE_STREET_SUCCESS
  constructor() {}
}

export class UpdateStreetFailure implements Action {
  readonly type = StreetsTypes.UPDATE_STREET_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = StreetsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = StreetsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateStreetRequest
  | UpdateStreetSuccess
  | UpdateStreetFailure
  | FetchStreetsSuccess
  | FetchStreetsFailure
  | FetchStreetsRequest
  | FetchStreetSuccess
  | FetchStreetFailure
  | FetchStreetRequest
  | CreateStreetRequest
  | CreateStreetSuccess
  | CreateStreetFailure
  | DeleteStreetRequest
  | DeleteStreetSuccess
  | DeleteStreetFailure
  | SetDefaultData
  | UpdateField
  | FetchStreetsRequest
  | FetchStreetsSuccess
  | FetchStreetsFailure
